import baseSearch from 'vue-src/store/modules/search/_base'

export default baseSearch({
  state: {
    filterset_name: 'mx_filter',
    _type: 'stock_item',
    mxfilter: undefined,
  },
  mutations: {
    setMxFilter(state, id) {
      state.mxfilter = id
    },
  },
  actions: {
    init({dispatch, state, commit}, {id}) {
      commit('setMxFilter', id)
      let init = dispatch('fetchFilterSet')
          .then(r => dispatch('fetchSearch'))
      commit('setInit', init)
      return init
    }
  },
  getters: {
    getSortFields(state){
      let fields = state.filterset.sort_fields?state.filterset.sort_fields:[]
      fields = fields.filter(x => x.value !== '_score')
      return fields
    },
  },
})



// WEBPACK FOOTER //
// ./ixcms/themes/jedco/src/vue-src/store/modules/search/mxcategory-items.js